<script>
import Cartesian from '../chart/Cartesian';

export default {
	name: 'BarChart',

	mixins: [
		Cartesian,
	],

	props: {
		barThickness: {
			type: Number,
			required: false,
			default: 10,
			description: 'Sets the thickness of single bars on the bar-chart',
		},
	},

	computed: {
		dataOptions() {
			return {
				barThickness: this.barThickness,
			};
		},

		chartOptions() {
			return {
				...this.cartesianOptions,
			};
		},
	},

	created() {
		this.chartId = 'bar';
		this.chartType = 'bar';
	},
};
</script>

<style lang="scss" scoped src="./bar-chart.scss" />
